import React from "react";
import { Marker, Tooltip } from "react-leaflet";
import { shallowEqual } from "react-redux";

import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import mapBusesIcons from "../MapBusesIcons";
import { dispatchCoordinates, fetchDataActiveBus, resetDataActiveBus, setActiveBus } from "../../redux/actions";
import { BusIconPopup, BusTooltipComponent } from "../MapBusesComponent";
import { getHeadwayStatusColor } from "../../utils/swiftlyHelpers";
import { UseTablesMapsStopsShape } from "../TableBigComponentMap";

const HeadwayPerformanceMapBuses = ({
  workingBusesToShow,
  showLineNumbers,
}: {
  workingBusesToShow: BusInfo[];
  showLineNumbers: boolean;
}): JSX.Element => {
  const dispatch: Dispatch = useAppDispatch();

  const [activeBus, currentZoomFromRedux]: [{ busId: string }, number] = useAppSelector(
    (state: RootState) => [state?.buses?.activeBus, state?.constantValues?.currentZoom],
    shallowEqual
  );

  //* Fetch route data, set bus as active
  const onClickHandler = async (bus: BusInfo): Promise<void> => {
    // console.log("bus:", bus);
    if (bus?.routeId && bus?.direction) {
      dispatch(fetchDataActiveBus(bus.routeId, bus.direction));
    } else {
      dispatch(resetDataActiveBus());
    }
    dispatch(setActiveBus(bus?.id));
    dispatch(dispatchCoordinates(bus.loc.lat, bus.loc.lon, currentZoomFromRedux));
  };

  const busesOnMapIcons: JSX.Element[] = workingBusesToShow?.map(
    (elem: BusInfo, index: number): JSX.Element => (
      <Marker
        key={elem.id}
        position={{
          lat: elem?.loc?.lat ?? 0,
          lng: elem?.loc?.lon ?? 0,
        }}
        icon={mapBusesIcons(
          elem?.colorStatus,
          elem?.addedStatus,
          elem?.isAtStop === true,
          activeBus && activeBus.busId === elem?.id,
          elem?.loc?.heading,
          true,
          elem?.headwayDeviationCategory
        )}
        eventHandlers={{ click: (): Promise<void> => onClickHandler(elem) }}
      >
        {showLineNumbers ? (
          <Tooltip
            //* offset switched off
            // offset={index % 2 === 0 ? [9, 0] : [-9, 0]}
            interactive={true}
            permanent={true}
            direction={index % 2 === 0 ? "right" : "left"}
            className={elem.subcontractorPKS ? "subcontractor-vehicle" : ""}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-start",
                alignItems: "center",
                alignContent: "center",
              }}
            >
              <BusTooltipComponent elem={elem} activeBus={activeBus} />
              {elem?.isAtStop ? (
                <HeadwayCategoryStatusDot color={getHeadwayStatusColor(elem?.headwayDeviationCategory)} />
              ) : null}
            </div>
          </Tooltip>
        ) : null}
        {/* //* Popup */}
        {activeBus && (activeBus.busId === "" || activeBus.busId === elem.id) ? <BusIconPopup bus={elem} /> : null}
      </Marker>
    )
  );

  return (
    <React.Fragment>
      {busesOnMapIcons}
      <UseTablesMapsStopsShape />
    </React.Fragment>
  );
};

export default HeadwayPerformanceMapBuses;

//* Headway category status dod
const HeadwayCategoryStatusDot = ({ color }: { color: string }): JSX.Element => {
  return (
    <React.Fragment>
      <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg">
        <circle cx="10" cy="10" r="8" fill={color} />
      </svg>
    </React.Fragment>
  );
};
